module.exports = __webpack_public_path__ + "img/矩形.2f6ead4c.svg";